import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Delete,
  GetAll,
  StatusItem,
} from "../../../../features/admin/master/city/Slice";
import {
  getAllCountries,
  getAllStates,
} from "../../../../features/admin/common/Slice";

export const IndexUse = () => {
  const dispatch = useDispatch();
  const [modalShow, setModalShow] = React.useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const countries = useSelector((state) => state.common.all_country);
  const states = useSelector((state) => state.common.all_states);
  const city = useSelector((state) => state.masters.city);

  const [name, setName] = useState("");
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");

  useEffect(() => {
    dispatch(getAllCountries());
  }, [dispatch]);

  useEffect(() => {
    fetch();
  }, [country, state, name]);

  useEffect(() => {
    if (country) {
      dispatch(getAllStates({ countryId: country.value })); // Fetch states when country is selected
    }
  }, [country, state, dispatch]);

  const fetch = async (page = city?.current_page) => {
    // await dispatch(AllCountry());
    await dispatch(
      GetAll({
        name: name,
        state_id: state ? state.value : null,
        country_id: country ? country.value : null,
        page: page,
        per_page: city?.per_page,
      }),
    );
  };

  const deleteData = async (id) => {
    try {
      await dispatch(Delete(id));
      setModalMessage("Deleted Successfully");
      setModalShow(true);
      await fetch();
      return true; // Success
    } catch (error) {
      setModalMessage("Delete Failed");
      setModalShow(true);
      console.error(error);
      return false; // Error
    }
  };

  const toggleStatus = async (id) => {
    try {
      const res = await dispatch(StatusItem(id));
      if (res.payload?.data?.success) {
        await fetch();
        setModalShow(true);
        return true;
      }
    } catch (error) {
      console.error(error);
      return false; // Error
    }
  };

  return {
    city,
    name,
    setName,
    fetch,
    deleteData,
    toggleStatus,
    country,
    countries,
    setCountry,
    state,
    states,
    setState,
    modalMessage,
    modalShow,
    setModalShow,
  };
};
